import { canonicalAttachmentUrl } from "./attachment-media";
import type { ImageAttachment } from "@/components/panels/image-preview-strip";

export function messageAttachments(
  content: unknown,
): ImageAttachment[] | undefined {
  if (!content || typeof content !== "object" || Array.isArray(content)) return;
  const images = (content as Record<string, unknown>).images;
  if (!Array.isArray(images)) return;
  const attachments = images.flatMap((value) => {
    if (!value || typeof value !== "object") return [];
    const item = value as Record<string, unknown>;
    if (typeof item.id !== "string" || typeof item.url !== "string") return [];
    // Restrict links supplied by message content to the upload API or http(s).
    if (
      !/^\/api\/v1\/uploads\//.test(item.url) &&
      !/^https?:\/\//.test(item.url)
    )
      return [];
    return [
      {
        id: item.id,
        imageId: item.id,
        url: canonicalAttachmentUrl(item.url),
        filename:
          typeof item.original_filename === "string"
            ? item.original_filename
            : undefined,
        contentType:
          typeof item.content_type === "string" ? item.content_type : undefined,
      },
    ];
  });
  return attachments.length ? attachments : undefined;
}
